import { DataFormat } from "utils/format/DataFormat";

export abstract class BasedB2CTransactionRequestModel {
  name?: string; 
  code?: string; //needForFilter
  transRef?: string; //needForFilter
  status?: string; //needForFilter
  type?: string; //needForFilter
  note?: string;
  user?: string; //needForFilter
  service?: string;
  partner?: string; //needForFilter
  order?: string;
  fromDate?: string; //needForFilter
  toDate?: string; //needForFilter
  created?: Array<Record<string, unknown>>; //needForFilter
  pagination?: boolean;
  page?: number; //needForFilter
  limit?: number; //needForFilter
  store?: string; //needForFilter
  userId?: string;

  constructor(data?: Partial<BasedB2CTransactionRequestModel>) {
    this.name = data?.name;
    this.code = data?.code;
    this.transRef = data?.transRef;
    this.status = data?.status;
    this.type = data?.type;
    this.note = data?.note;
    this.user = data?.user;
    this.service = data?.service;
    this.partner = data?.partner;
    this.order = data?.order;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.created = data?.created;
    this.pagination = data?.pagination;
    this.page = data?.page;
    this.limit = data?.limit;
    this.store = data?.store;
    this.userId = data?.userId;
  }

  public removeUnknowValue?<T extends BasedB2CTransactionRequestModel>(data: T) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>,
    );
  }
}